export default __webpack_public_path__ + "static/media/more-photos.77a8cda2.svg";